var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ui-grid-form',{attrs:{"columns":_vm.columns,"model":_vm.model,"mode-edit":"form","allow-add":true,"allow-del":true,"header":true},on:{"change":function (v) { return _vm.$emit('change', v); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }